import { render, staticRenderFns } from "./CourseListTab.vue?vue&type=template&id=ef18b1fe&scoped=true"
import script from "./CourseListTab.vue?vue&type=script&lang=js"
export * from "./CourseListTab.vue?vue&type=script&lang=js"
import style0 from "./CourseListTab.vue?vue&type=style&index=0&id=ef18b1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef18b1fe",
  null
  
)

export default component.exports